exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".active[data-v-248dc001]{color:#d10007!important}.navbar[data-v-248dc001]{max-height:100px}", ""]);

// exports
